<template>
  <div class="fuel-utilization-filters">
  <div class="grid fuel-utilization-filters__container">
    <div class="filter-work-orders__department filter-selection">
      <div class="filter-selection__body">
        <StoreConnectedSelect class="filter-selection__select h-full-width" placeholder="Department" :store="store" name="departments" :options="departmentsList" multiple clear-button></StoreConnectedSelect>
      </div>
    </div>

    <div class="filter-work-orders__objective filter-selection">
      <div class="filter-selection__body">
        <StoreConnectedSelect class="filter-selection__select h-full-width" placeholder="Objective" :store="store" name="objectives" :options="objectivesList" multiple clear-button></StoreConnectedSelect>
      </div>
    </div>

    <div class="filter-work-orders__specialty filter-selection">
      <div class="filter-selection__body">
        <StoreConnectedSelect class="filter-selection__select h-full-width" placeholder="Specialty" :store="store" name="specialties" :options="specialtiesList" multiple clear-button></StoreConnectedSelect>
      </div>
    </div>

    <div class="fuel-utilization__filter fuel-utilization__filter--date-range">
      <div class="grid filter__form">
        <div class="grid__col--6 filter-sales-dates__from-date filter-selection">
          <div class="filter-selection__body">
            <StoreConnectedDatePicker
                class="filter-selection__select filter-selection__select--date"
                :store="store"
                placeholder="From"
                name="dateFrom"
                format="MM/yyyy"
                :disabled-dates="disabledRangeFrom"
                minimum-view="month"
            ></StoreConnectedDatePicker>
          </div>
        </div>

        <div class="grid__col--6 filter-sales-dates__to-date filter-selection">
          <div class="filter-selection__body">
            <StoreConnectedDatePicker
                class="filter-selection__select filter-selection__select--date"
                :store="store"
                placeholder="To"
                name="dateTo"
                format="MM/yyyy"
                :disabled-dates="disabledRangeTo"
                minimum-view="month">
            </StoreConnectedDatePicker>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>



<script>
  import { mapGetters } from 'vuex';
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedDatePicker from '../../form-items/StoreConnectedDatePicker.vue';

  export default {
    name: 'FilterWorkOrderDetails',
    components: {
      StoreConnectedSelect,
      StoreConnectedDatePicker,
    },
    data() {
      return {
        store: 'fuelUtilization',
      }
    },
    mounted() {
      this.$store.dispatch('fuelUtilization/getDateList');
    },
    computed: {
      ...mapGetters('fuelUtilization', [
        'departmentsList',
        'objectivesList',
        'specialtiesList',
        'disabledRangeFrom',
        'disabledRangeTo',
        'dateTo',
        'dateFrom',
      ]),
    },
    watch: {
      disabledRangeFrom() {
        if (this.dateFrom < this.disabledRangeFrom.to) {
          this.$store.dispatch('fuelUtilization/setProperty', { key: 'dateFrom', value: this.disabledRangeFrom.to });
        }
        if (this.dateFrom > this.disabledRangeFrom.from) {
          this.$store.dispatch('fuelUtilization/setProperty', { key: 'dateFrom', value: this.disabledRangeFrom.from });
        }
      },
      disabledRangeTo() {
        if (this.dateTo < this.disabledRangeTo.to) {
          this.$store.dispatch('fuelUtilization/setProperty', { key: 'dateTo', value: this.disabledRangeTo.to });
        }
        if (this.dateTo > this.disabledRangeTo.from) {
          this.$store.dispatch('fuelUtilization/setProperty', { key: 'dateTo', value: this.disabledRangeTo.from });
        }
      },
    },
  };
</script>
